import React from 'react';
import { Card, Table } from 'react-bootstrap';
import { getRecentProjects, removeRecentProject, clearRecentProjects } from '../../../utils/recentProjectsUtility';
import { Link } from 'react-router-dom';
import { Edit, Check, Trash2 } from 'lucide-react';
import moment from 'moment';
import { Trans } from 'react-i18next';

export default class RecentProjects extends React.Component {

    constructor() {
        super();

        this.state = {
            recentProjects: []
        };
    }

    componentDidMount() {

        this.setState((state) => {
            const recentProjects = Object.values(getRecentProjects());
            recentProjects.sort(function (a, b) { return a.updateDate < b.updateDate });

            return {
                'recentProjects': recentProjects
            };
        });
    }

    removeProject(project) {
        this.setState((state) => {
            const recentProjects = Object.values(removeRecentProject(project.id));
            recentProjects.sort(function (a, b) { return a.updateDate > b.updateDate });

            return {
                'recentProjects': recentProjects
            };
        });
    }

    clearProjects() {
        this.setState((state) => {
            const recentProjects = Object.values(clearRecentProjects());
            recentProjects.sort(function (a, b) { return a.updateDate > b.updateDate });

            return {
                'recentProjects': recentProjects
            };
        });
    }

    renderList() {

        // if (this.state.recentProjects.length === 0 ){
        //     return <span>No recent projects</span>
        // }

        return this.state.recentProjects.map(project => {

            const driverUrl = `/projects/${project.id}/driver`;

            const doneText = project.done
                ? <Check style={{ color: "#34A853" }} size="1.25rem" />
                : <Edit size="1.25rem" />;

            return (
                <tr key={project.id} style={{ textAlign: "center" }}>
                    <td style={{ padding: "0.25rem" }}>
                        {doneText}
                    </td>
                    <td>
                        <Link to={driverUrl} className="a-cloud-list">
                            {project.name}
                        </Link>
                    </td>
                    {/* <td>
                        {moment(project.creationDate).format('DD/MM/YYYY HH:mm')}
                    </td> */}
                    <td>
                        {moment(project.updateDate).format('DD/MM/YYYY HH:mm')}
                    </td>
                    <td style={{ padding: "0.25rem" }}>
                        <Trash2 className="delete-recent-project" style={{ cursor: "pointer", color: "black" }} size="1.25rem" onClick={(e) => this.removeProject(project)} />
                    </td>
                </tr>
            );
        });
    }

    render() {

        const clearAllElement = this.state.recentProjects.length > 0
            ? <div style={{ marginBottom: '0', float: 'right', cursor: 'pointer', maxHeight: '19px' }} onClick={(e) => this.clearProjects()} ><Trans i18nKey="Clear_all" /></div>
            : null;
        return (
            <Card className="card-recent-projects" >
                <div className='card-header-recent-project'>
                    <h6 style={{ marginBottom: '0', float: 'left' }}><Trans i18nKey="Recent_Projects" /></h6>
                    {clearAllElement}
                </div>
                <Card.Body style={{ padding: '0', height: '100%', maxHeight: "83.5vh" }}>
                    <Table responsive striped bordered hover size="sm" style={{ marginBottom: '0' }}>
                        <thead>
                            <tr style={{ textAlign: "center" }}>
                                <th style={{ width: "5rem" }}><Trans i18nKey="Status" /></th>
                                <th><Trans i18nKey="Project_Name" /></th>
                                {/* <th>Creation Date</th> */}
                                <th><Trans i18nKey="Update_Date" /></th>
                                <th style={{ width: '1.5em' }}></th>
                            </tr>
                        </thead>
                        <tbody className="tbody-project-cloud-list">
                            {this.renderList()}
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>
        );
    }
}
